import React, { useEffect, useState } from "react";

import env from "../../../env";
import errortrans from "../../../translate/error";
import tabletrans from "../../../translate/tables";
import formtrans from "../../../translate/forms";

import StoryDetails from "./StoryDetails";
import StoryImage from "./StoryImage";
import UploadVideo from "./UploadVideo";

import Cookies from "universal-cookie";

const cookies = new Cookies();

function StoryDetailHolder(props) {
  const url = window.location.pathname.split("/")[3];

  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;

  const [error, setError] = useState({
    errorText: "",
    errorColor: "brown",
  });

  const token = cookies.get(env.cookieName);

  const [content, setContent] = useState("");
  const [ProductList, setProductList] = useState();
  const [sliderChange, setSliderChange] = useState("");
  const [listCat, setListCat] = useState([]);

  // وضعیت آپلود فایل‌ها
  const [uploadStatus, setUploadStatus] = useState({});

  /*
    مثال:

    {
      imageUrl: "success",
      videoUrl: "uploading"
    }
  */

  const handleUploadStatus = (key, status) => {
    setUploadStatus((prev) => ({
      ...prev,
      [key]: status,
    }));
  };

  // آیا آپلودی در حال انجام است؟
  const isUploading = Object.values(uploadStatus).some(
    (status) => status === "uploading",
  );

  // آیا آپلودی با خطا مواجه شده؟
  const hasUploadError = Object.values(uploadStatus).some(
    (status) => status === "error",
  );

  useEffect(() => {
    if (url === "new") return;

    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ storyId: url }),
    };

    fetch(env.siteApi + "/panel/document/fetch-story", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({
              errorText: result.error,
              errorColor: "brown",
            });

            setTimeout(
              () =>
                setError({
                  errorText: "",
                  errorColor: "brown",
                }),
              3000,
            );
          } else {
            setError({
              errorText: "سرویس پیدا شد",
              errorColor: "green",
            });

            setContent(result.filter);

            setTimeout(
              () =>
                setError({
                  errorText: "",
                  errorColor: "brown",
                }),
              2000,
            );
          }
        },
        (error) => {
          console.log(error);
        },
      );
  }, []);

  const saveSlider = () => {
    // اگر هنوز آپلودی در حال انجام است
    if (isUploading) {
      setError({
        errorText: "لطفاً تا پایان آپلود فایل صبر کنید",
        errorColor: "brown",
      });

      setTimeout(
        () =>
          setError({
            errorText: "",
            errorColor: "brown",
          }),
        3000,
      );

      return;
    }

    // اگر آپلودی با خطا مواجه شده
    if (hasUploadError) {
      setError({
        errorText: "آپلود فایل با خطا مواجه شده است",
        errorColor: "brown",
      });

      setTimeout(
        () =>
          setError({
            errorText: "",
            errorColor: "brown",
          }),
        3000,
      );

      return;
    }

    const postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({
        storyId: url,
        ...sliderChange,
      }),
    };

    fetch(env.siteApi + "/panel/document/update-story", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({
              errorText: result.error,
              errorColor: "brown",
            });

            setTimeout(
              () =>
                setError({
                  errorText: "",
                  errorColor: "brown",
                }),
              3000,
            );
          } else {
            setError({
              errorText: result.success,
              errorColor: "green",
            });

            setTimeout(() => (window.location.href = "/Story"), 2000);
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };

  console.log(sliderChange);

  return (
    <div className="new-item" style={{ direction }}>
      <div className="create-product">
        <h4>ویرایش استوری</h4>

        {content || url === "new" ? (
          <div className="pages-wrapper">
            <div className="item-box">
              <StoryDetails
                direction={direction}
                lang={lang}
                content={content}
                setSliderChange={setSliderChange}
                sliderChange={sliderChange}
                token={token}
                listCat={listCat}
              />
            </div>

            <div
              className="imageHolder"
              style={{ display: "flex", flexDirection: "row" }}
            >
              {/* تصویر استوری */}
              <StoryImage
                lang={lang}
                content={content}
                value="imageUrl"
                sliderChange={sliderChange}
                part={1}
                setSliderChange={setSliderChange}
                onUploadStatus={handleUploadStatus}
              />

              {/* ویدیوی استوری */}
              <UploadVideo
                lang={lang}
                content={content}
                value="videoUrl"
                sliderChange={sliderChange}
                part={2}
                setSliderChange={setSliderChange}
                onUploadStatus={handleUploadStatus}
              />
            </div>

            <div className="create-btn-wrapper">
              <div
                className={`save-btn ${
                  isUploading || hasUploadError ? "save-btn-disabled" : ""
                }`}
                onClick={
                  !isUploading && !hasUploadError ? saveSlider : undefined
                }
                style={{
                  opacity: isUploading || hasUploadError ? 0.5 : 1,
                  cursor:
                    isUploading || hasUploadError ? "not-allowed" : "pointer",
                }}
              >
                {isUploading ? "در حال آپلود..." : formtrans.saveChanges[lang]}
              </div>

              <div
                className="cancel-btn"
                onClick={() => (window.location.href = "/Story")}
              >
                {formtrans.cancel[lang]}
              </div>
            </div>
          </div>
        ) : (
          <div>{env.loader}</div>
        )}
      </div>
    </div>
  );
}

export default StoryDetailHolder;
